// import { type LucideIcon } from "lucide-react";
import {
  SidebarGroup,
  SidebarMenu,
  // SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  // SidebarMenuSubButton,
  // SidebarMenuSubItem,
} from "../../components/shadcn-ui/sidebar";
import { Link } from "react-router-dom";
import { Card, CardContent } from "../../components/shadcn-ui/card";
import { type DashboardOption } from "../../pages/dashboard/dashBoardOption";
import React from "react";
import { PermissionNavItem } from "features/Permission/PermissionNavItem";
import { EmiCalculator } from "features/emiCalculator/EmiCalculator";

interface NavMainProps {
  items: DashboardOption[];
}

export const NavMain = ({ items }: NavMainProps) => {
  return (
    <SidebarGroup>
      <img
        className="block md:hidden text-center"
        src="/assets/logo.png"
        width="124px"
        alt=""
      ></img>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuSub>
            {items.map((props, index) => {
              return (
                <React.Fragment key={index}>
                  <PermissionNavItem
                    key={props.linkTo}
                    requiredPermissions={props.requiredPermissions}
                  >
                    <SideBarNavOption {...props} />
                  </PermissionNavItem>
                </React.Fragment>
              );
            })}
            <EmiCalculator floatingCard className="w-full" />
          </SidebarMenuSub>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
};

const SideBarNavOption = ({
  linkTo,
  title,
  icon,
  bgColor,
}: DashboardOption) => {
  return (
    <Link to={linkTo}>
      <Card className={`${bgColor} flex items-center px-3 py-2`}>
        <img src={`${icon}`} alt="" style={{ height: "20px" }} />
        <CardContent className="p-0 ml-4">{title}</CardContent>
      </Card>
    </Link>
  );
};
